"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var BrandGwsGameProviderSegmentationEditor = /** @class */ (function (_super) {
    __extends(BrandGwsGameProviderSegmentationEditor, _super);
    //private SID_AT: number;
    //private SID_AL: number;
    function BrandGwsGameProviderSegmentationEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandGwsGameProviderSegmentationEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AZ = this.props.ListGwsGameProviderZonesAvail.Subscribe("*", function (id, data) {
            _this.setState({ gws_zones_avail: data.data });
        });
        this.SID_AB = this.props.ListPlayerBehaviorTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ usr_behavior_avail: data.data });
        });
        /*this.SID_AT = this.props.ListTresholdBehaviorTypesAvail.Subscribe("*", (id, data) => {

            this.setState({ app_treshold_avail: data.data });

        });*/
        /*this.SID_AL = this.props.ListBonusLevelsAvail.Subscribe("*", (id, data) => {

            this.setState({ usr_levels_avail: data.data });

        });*/
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    /*treshold_rtp_type_code: _item.treshold_rtp_type_code,
                    treshold_rtp_type_title: _item.treshold_rtp_type_title,
                    treshold_rtp_x100: _item.treshold_rtp_x100,
                    is_treshold_rtp: _item.is_treshold_rtp,
                    treshold_dep_count_type_code: _item.treshold_dep_count_type_code,
                    treshold_dep_count_type_title: _item.treshold_dep_count_type_title,
                    treshold_deposit_count: _item.treshold_deposit_count,
                    is_treshold_deposit_count: _item.is_treshold_deposit_count,
                    treshold_inout_percent_type_code: _item.treshold_inout_percent_type_code,
                    treshold_inout_percent_type_title: _item.treshold_inout_percent_type_title,
                    treshold_inout_percent_x100: _item.treshold_inout_percent_x100,
                    is_treshold_inout_percent: _item.is_treshold_inout_percent,
                    treshold_bonus_level_type_code: _item.treshold_bonus_level_type_code,
                    treshold_bonus_level_type_title: _item.treshold_bonus_level_type_title,
                    is_treshold_bonus_level: _item.is_treshold_bonus_level,
                    treshold_bonus_level_id: _item.treshold_bonus_level_id,
                    treshold_bonus_level_title: _item.treshold_bonus_level_title,*/
                    player_profit_status_code: _item.player_profit_status_code,
                    player_profit_status_title: _item.player_profit_status_title,
                    custom_gameprovider_zone_id: _item.custom_gameprovider_zone_id,
                    custom_gameprovider_zone_title: _item.custom_gameprovider_zone_title,
                    description: _item.description,
                    gws_zones_avail: [],
                    usr_behavior_avail: [],
                });
            }
        }
        else {
            this.setState({
                //treshold_rtp_type_code: 0,
                //treshold_rtp_type_title: "",
                //treshold_rtp_x100: 10,
                //is_treshold_rtp: false,
                gws_zones_avail: [],
                //treshold_dep_count_type_code: 0,
                //treshold_dep_count_type_title: "",
                //treshold_deposit_count: 0,
                //is_treshold_deposit_count: false,
                //treshold_inout_percent_type_code: 0,
                //treshold_inout_percent_type_title: "",
                //treshold_inout_percent_x100: 10,
                //is_treshold_inout_percent: false,
                //treshold_bonus_level_type_code: 0,
                //treshold_bonus_level_type_title: "",
                //is_treshold_bonus_level: false,
                //treshold_bonus_level_id: 0,
                //treshold_bonus_level_title: "",
                player_profit_status_code: 0,
                player_profit_status_title: "",
                custom_gameprovider_zone_id: 0,
                custom_gameprovider_zone_title: "",
                description: "",
                usr_behavior_avail: [],
            });
        }
        this.props.ListGwsGameProviderZonesAvail.LoadDataByBrandAndCurrency(this.props.rootRecord.brand_id, this.props.rootRecord.app_currency_id);
        this.props.ListPlayerBehaviorTypesAvail.LoadData();
        this.props.ListTresholdBehaviorTypesAvail.LoadData();
        this.props.ListBonusLevelsAvail.LoadData(this.props.rootRecord.brand_id);
        this.doReSetRules();
    };
    BrandGwsGameProviderSegmentationEditor.prototype.componentWillUnmount = function () {
        this.props.ListGwsGameProviderZonesAvail.UnSubscribe(this.SID_AZ);
        this.props.ListPlayerBehaviorTypesAvail.UnSubscribe(this.SID_AB);
        //this.props.ListTresholdBehaviorTypesAvail.UnSubscribe(this.SID_AT);
        //this.props.ListBonusLevelsAvail.UnSubscribe(this.SID_AL);
    };
    BrandGwsGameProviderSegmentationEditor.prototype.doReSetRules = function () {
        this.setState({
            //treshold_rtp_type_rules: { isError: false },
            //treshold_rtp_x100_rules: { isError: false },
            //treshold_dep_count_type_rules: { isError: false },
            //treshold_deposit_count_rules: { isError: false },
            //treshold_inout_percent_type_rules: { isError: false },
            //treshold_inout_percent_x100_rules: { isError: false },
            //treshold_bonus_level_type_rules: { isError: false },
            //treshold_bonus_level_rules: { isError: false },
            player_profit_status_rules: { isError: false },
            custom_gameprovider_zone_rules: { isError: false }
        });
    };
    BrandGwsGameProviderSegmentationEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        /*if (this.state.is_treshold_rtp) {

            if ((this.state.treshold_rtp_type_code <= 0) || (this.state.treshold_rtp_type_title.length === 0)) {
                this.setState({ treshold_rtp_type_rules: { isError: true, errorMessage: "Поле [критерий ртп] не выбран!" } })
                return false;
            }
            if ((this.state.treshold_rtp_x100 <= 0) || (this.state.treshold_rtp_x100 > 100)) {
                this.setState({ treshold_rtp_x100_rules: { isError: true, errorMessage: "Поле [значение критерия ртп] указано некорректно!" } })
                return false;
            }

        }*/
        /*if (this.state.is_treshold_deposit_count) {

            if ((this.state.treshold_dep_count_type_code <= 0) || (this.state.treshold_dep_count_type_title.length === 0)) {
                this.setState({ treshold_dep_count_type_rules: { isError: true, errorMessage: "Поле [критерий кол-ва депозитов] не выбран!" } })
                return false;
            }
            if ((this.state.treshold_deposit_count <= 0)) {
                this.setState({ treshold_deposit_count_rules: { isError: true, errorMessage: "Поле [значение критерия кол-ва депозитов] указано некорректно!" } })
                return false;
            }

        }*/
        /*if (this.state.is_treshold_inout_percent) {

            if ((this.state.treshold_inout_percent_type_code <= 0) || (this.state.treshold_inout_percent_type_title.length === 0)) {
                this.setState({ treshold_inout_percent_type_rules: { isError: true, errorMessage: "Поле [критерий инаут] не выбран!" } })
                return false;
            }
            if ((this.state.treshold_inout_percent_x100 <= 0) || (this.state.treshold_inout_percent_x100 > 100)) {
                this.setState({ treshold_inout_percent_x100_rules: { isError: true, errorMessage: "Поле [значение критерия инаут] указано некорректно!" } })
                return false;
            }

        }*/
        /*if (this.state.is_treshold_bonus_level) {

            if ((this.state.treshold_bonus_level_type_code <= 0) || (this.state.treshold_bonus_level_type_title.length === 0)) {
                this.setState({ treshold_bonus_level_type_rules: { isError: true, errorMessage: "Поле [критерий уровня] не выбран!" } })
                return false;
            }
            if ((this.state.treshold_bonus_level_id <= 0) || (this.state.treshold_bonus_level_title.length === 0)) {
                this.setState({ treshold_bonus_level_rules: { isError: true, errorMessage: "Поле [значение уровня] не выбрано!" } })
                return false;
            }

        }*/
        if ((this.state.player_profit_status_code <= 0) || (this.state.player_profit_status_title.length === 0)) {
            this.setState({ player_profit_status_rules: { isError: true, errorMessage: "Поле [статус игрока] не выбрано!" } });
            return false;
        }
        if ((this.state.custom_gameprovider_zone_id <= 0) || (this.state.custom_gameprovider_zone_title.length === 0)) {
            this.setState({ custom_gameprovider_zone_rules: { isError: true, errorMessage: "Поле [игровая зона] не выбрано!" } });
            return false;
        }
        return true;
    };
    BrandGwsGameProviderSegmentationEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                //treshold_rtp_type_code: this.state.treshold_rtp_type_code,
                //treshold_rtp_x100: this.state.treshold_rtp_x100,
                //is_treshold_rtp: this.state.is_treshold_rtp,
                //treshold_dep_count_type_code: this.state.treshold_dep_count_type_code,
                //treshold_deposit_count: this.state.treshold_deposit_count,
                //is_treshold_deposit_count: this.state.is_treshold_deposit_count,
                //treshold_inout_percent_type_code: this.state.treshold_inout_percent_type_code,
                //treshold_inout_percent_x100: this.state.treshold_inout_percent_x100,
                //is_treshold_inout_percent: this.state.is_treshold_inout_percent,
                //treshold_bonus_level_type_code: this.state.treshold_bonus_level_type_code,
                //treshold_bonus_level_id: this.state.treshold_bonus_level_id,
                //is_treshold_bonus_level: this.state.is_treshold_bonus_level,
                player_profit_status_code: this.state.player_profit_status_code,
                custom_gameprovider_zone_id: this.state.custom_gameprovider_zone_id,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сегментация геймпровайдера изменена!");
            });
        }
    };
    BrandGwsGameProviderSegmentationEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_gws_gameprovider_id: this.props.rootRecord.key,
                //treshold_rtp_type_code: this.state.treshold_rtp_type_code,
                //treshold_rtp_x100: this.state.treshold_rtp_x100,
                //is_treshold_rtp: this.state.is_treshold_rtp,
                //treshold_dep_count_type_code: this.state.treshold_dep_count_type_code,
                //treshold_deposit_count: this.state.treshold_deposit_count,
                //is_treshold_deposit_count: this.state.is_treshold_deposit_count,
                //treshold_inout_percent_type_code: this.state.treshold_inout_percent_type_code,
                //treshold_inout_percent_x100: this.state.treshold_inout_percent_x100,
                //is_treshold_inout_percent: this.state.is_treshold_inout_percent,
                //treshold_bonus_level_type_code: this.state.treshold_bonus_level_type_code,
                //treshold_bonus_level_id: this.state.treshold_bonus_level_id,
                //is_treshold_bonus_level: this.state.is_treshold_bonus_level,
                player_profit_status_code: this.state.player_profit_status_code,
                custom_gameprovider_zone_id: this.state.custom_gameprovider_zone_id,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сегментация геймпровайдера добавлена!");
            });
        }
    };
    BrandGwsGameProviderSegmentationEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandGwsGameProviderSegmentationEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить сегментацию геймпровайдера";
        }
        else {
            return "Изменить сегментацию геймпровайдера";
        }
    };
    BrandGwsGameProviderSegmentationEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 380 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Статус игрока:", placeholder: "Выберите статус игрока" }, value: { key: this.state.player_profit_status_code, value: this.state.player_profit_status_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_profit_status_code: newVal.key,
                        player_profit_status_title: newVal.value,
                        player_profit_status_rules: { isError: false }
                    });
                }, items: this.state.usr_behavior_avail, required: true, rules: this.state.player_profit_status_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игровая зона:", placeholder: "Выберите игровую зону" }, value: { key: this.state.custom_gameprovider_zone_id, value: this.state.custom_gameprovider_zone_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        custom_gameprovider_zone_id: newVal.key,
                        custom_gameprovider_zone_title: newVal.value,
                        custom_gameprovider_zone_rules: { isError: false }
                    });
                }, items: this.state.gws_zones_avail, required: true, rules: this.state.custom_gameprovider_zone_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandGwsGameProviderSegmentationEditor;
}(React.Component));
exports.default = BrandGwsGameProviderSegmentationEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/gateways/gameprovider/BrandGwsGameProviderSegmentationEditor.tsx
// module id = 1796
// module chunks = 0